import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
export async function refreshSession() {
  if (!refreshing) {
    refreshing = axios.post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .then(() => true).catch(() => false).finally(() => { refreshing = null; });
  }
  return refreshing;
}

const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/me"];
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config || {};
  if (error.response?.status === 401 && !cfg._retried && !NO_RETRY.some((p) => (cfg.url || "").includes(p))) {
    cfg._retried = true;
    if (await refreshSession()) return api(cfg);
    window.dispatchEvent(new Event("respondia:logout"));
  }
  if (error.response?.status === 403 && error.response?.data?.demo_cta) {
    window.dispatchEvent(new Event("respondia:demo-cta"));
    return new Promise(() => {}); // CTA affiché : la page ne montre pas d'erreur technique
  }
  if (error.response?.status === 402) {
    if (!window.location.pathname.startsWith("/app/billing/")) window.location.assign("/app/billing/pending");
    return Promise.resolve({ data: [], status: 402, config: cfg, blocked: true });
  }
  return Promise.reject(error);
});

export async function authFetch(url, options = {}) {
  let res = await fetch(url, { credentials: "include", ...options });
  if (res.status === 401 && (await refreshSession())) res = await fetch(url, { credentials: "include", ...options });
  return res;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
